export default {
  solutions: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbCurrent: 'Zgjidhjet',
    hero: {
      eyebrow: 'Zgjidhjet',
      title: 'Zgjidhja e duhur për çdo pronë',
      lead: 'Qoftë shtëpi private, hapësirë tregtare apo magazinë – gjejmë bashkë sistemin optimal të kamerave për kërkesat tuaja.',
    },
    grid: {
      eyebrow: 'Zgjidhjet për pronat në një vështrim',
      title: 'Gjashtë fusha – një premtim: siguri e vërtetë',
      lead: 'Çdo kartë të çon në një pamje të veçantë me pika tipike mbikëqyrjeje dhe zgjidhje teknike të përshtatshme.',
    },
    tag: { privat: 'Privat', gewerbe: 'Biznes', innen: 'Brenda', außen: 'Jashtë', neu: 'I ri', erweiterung: 'Zgjerim' },
    more: 'Mëso më shumë',
    cta: {
      title: 'Nuk jeni i sigurt se cila zgjidhje përshtatet?',
      lead: 'Analizojmë bashkë pronën tuaj dhe ju rekomandojmë kombinimin e duhur të kamerave, regjistrimit dhe aksesorëve.',
      primary: 'Konsultim pa detyrim',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
};